var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('table',{ref:"tablecache",staticClass:"table table-hover mw-100"},[_vm._m(0),_c('tbody',{on:{"click":_vm.handleClick}})])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Key")]),_c('th',[_vm._v("Value")]),_c('th',[_vm._v("Action")])])])
}]

export { render, staticRenderFns }